import vendedorService from '../../services/vendedor/VendedorService'

// Mesma forma do ClienteStore: só o loading é compartilhado, a lista vai no
// retorno da action.
export const vendedorModule = {
  namespaced: true,
  state: {
    loading: false,
  },
  mutations: {
    SET_LOADING(state, payload) {
      state.loading = payload
    },
  },
  actions: {
    async fetchVendedores({ commit }, params = {}) {
      commit('SET_LOADING', true)
      try {
        const response = await vendedorService.getVendedores(params)
        return (response && response.data) || []
      } finally {
        commit('SET_LOADING', false)
      }
    },
    // Exact lookup by code — see the equivalent action in ClienteStore.
    async findVendedorByCodigo(context, codigo) {
      const response = await vendedorService.getVendedores({ codigo, limit: 1 })
      const vendedores = (response && response.data) || []
      return vendedores.length ? vendedores[0] : null
    },
  },
  getters: {
    loadingVendedores: (state) => state.loading,
  },
}
